import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { distinctUntilKeyChanged, map, switchMap } from 'rxjs/operators';
import { AuthService } from '../root/auth.service';
import { InternalService } from '../root/internal.service';
import { TrailerBaseDetails, TrailerStatus } from '../types';

@Injectable({
  providedIn: 'root',
})
export class TrailersService {
  private trailerStatus$$ = new BehaviorSubject<TrailerStatus>(null);

  private allTrailers$$ = new BehaviorSubject<TrailerBaseDetails[]>([]);
  public get trailerStatus$(): Observable<TrailerStatus> {
    return this.trailerStatus$$.asObservable();
  }
  public get allTrailers$(): Observable<TrailerBaseDetails[]> {
    return this.allTrailers$$.asObservable();
  }
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private internalService: InternalService,
  ) {
    combineLatest([
      this.authService.userInfo$.pipe(distinctUntilKeyChanged('companyId')),
      this.internalService.isInternal$,
    ])
      .pipe(
        switchMap(([userInfo, internal]) => {
          if (!userInfo || !internal) {
            return of({ status: null, details: [] });
          }
          return combineLatest([
            this.httpClient.get<TrailerStatus>(`${environment.api}/v1/admin/trailer_status`),
            this.httpClient.get<TrailerBaseDetails[]>(`${environment.api}/v2/amp/internal/all_trailers`),
          ]).pipe(
            map(([status, details]) => {
              return { status, details };
            }),
          );
        }),
      )
      .subscribe(({ status, details }) => {
        this.trailerStatus$$.next(status);
        this.allTrailers$$.next(details);
      });
  }
}
